import moment from "moment";
import React from "react";
import { capitalize } from "../../../shared/utils/stringUtils";
import { LoadingError } from "../../components";
import { Table } from "../../components/Molecules/Table/Table";
import {
  DATE_FORMAT,
  PRE_APPT_COLUMNS_DEFINE,
} from "../../constants/AppConstants";
import { RecallsAppointment } from "../../types/ApiTypes";
import "../WebAppointments.css";

export const RecallsApptTable = ({
  res,
  loading,
  columns,
  error,
}: {
  res?: RecallsAppointment[];
  loading?: boolean;
  columns: string[];
  error?: boolean;
}) => {
  const userColumns = PRE_APPT_COLUMNS_DEFINE.map((item, idx) => ({
    ...item,
    idx,
  })).filter((item) => columns.includes(item.id));
  const columnsIndexes = userColumns.map((item) => item.idx);
  const tableData =
    res &&
    res
      .map((item) => [
        capitalize(moment(item.commAt).format(`${DATE_FORMAT} hh:mm A`)),
        capitalize(item.patientID),
        `${capitalize(item.firstName)} ${capitalize(item.lastName)}`,
        `${capitalize(item.locationName)} - ${capitalize(item.providerName)}`,
        capitalize(item.commModality),
        capitalize(item.commTo),
        capitalize(item.commStatusText),
        capitalize(item.response),
        capitalize(item.recallReason),
      ])
      .map((item) => item.filter((_, idx) => columnsIndexes.includes(idx)));

  return !error ? (
    <>
      <Table
        colums={userColumns.map((item) => item.label)}
        datas={tableData || []}
        loading={loading}
      />
    </>
  ) : (
    <LoadingError />
  );
};
